import shuffle from "lodash/shuffle";
import { LoadingOptimizedImage } from "components/elements/LoadingOptimizedImage";
import { useSharedMediaStyles } from "../media/styles";
import { MediaSkeleton } from "../skeleton/MediaSkeleton";
import { useTranslate } from "components/providers/LocalizationProvider";
import { Box, Stack } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { Event, EventDivision } from "graphql/generated/types";
import { useMemo } from "react";

interface AsideProps {
    media: Event["media"];
    eventDivision: EventDivision;
    shouldLink: boolean;
}

export const EventDivisionItemAside: React.FC<AsideProps> = ({ media, eventDivision, shouldLink }) => {
    const size = 64;
    const sharedMediaClasses = useSharedMediaStyles();
    const eventMediaAltText = useTranslate("Event media");
    const thumbnail = useMemo(() => shuffle(media.filter(media => media.heat?.eventDivision?.id === eventDivision.id))[0], []);

    return (
        <Stack direction="row" alignItems="center" spacing={2} marginLeft={2}>
            {thumbnail && <Box width={size} height={size} position="relative">
                <LoadingOptimizedImage
                    className={sharedMediaClasses.thumbnail}
                    src={thumbnail.url}
                    width={size}
                    height={size}
                    alt={eventMediaAltText}
                    loader={<MediaSkeleton width={size} height={size} />}
                />
            </Box>}
            {shouldLink && <ChevronRight />}
        </Stack>
    );
};
